import React, { Component } from 'react';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

import { Request } from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Header from './../../APP/COMPONENTS/Header';
import LeftNav from './../../APP/COMPONENTS/LeftNav';
import Loader from './../../APP/COMPONENTS/Loader';
import InfoModal from "./../../APP/COMPONENTS/InfoModal"

function mapStateToProps(state, myProps) {
    return {
        USER: state.USER,
        TO_ORDER_PRODUCTS: state.TO_ORDER_PRODUCTS
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}


class Products extends Component {
    constructor(props) {
        super(props);
        this.state = {
            USER: this.props.USER,
            LOADED: false,
            PRODUCTS: false,
            GROUPS: false,
            FILTER: {
                TITLE: null,
                GROUP: null,
                ARCHIVE: 0,
                DISABLED: 0,
                OUTOFSTOCK: 0
            },
            INFO_MODAL: false
        }
    }

    componentDidMount = () => {
        this.fetchProducts();
    }


    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.USER !== prevProps.USER) {
            this.setState({ USER: this.props.USER });
        }
    }

    fetchProducts = async () => {
        try {
            let SEND_DATA = {
                action: 'supplierProducts',
                supplier_apikey: this.props.USER.supplier_apikey
            };

            let data = await Request(SEND_DATA, CONFIG.API_GATE);
            if (data !== false) {
                this.setState({ PRODUCTS: data.products, GROUPS: data.groups, LOADED: true });
            } else {
                this.setState({ LOADED: true });
            }
        } catch (error) {
        }
    }

    renderProducts = () => {
        if (this.state.LOADED) {
            if (this.state.PRODUCTS) {
                let PRODUCTS = this.filterProducts();
                let TBODY = this.renderProductsRows(PRODUCTS);
                let HEADER = this.renderProductsTableHeader();

                return (
                    <div className="table_holder">
                        <table id="products_table" className="products_table" cellPadding="0" cellSpacing="0">
                            { HEADER }
                            { TBODY }
                        </table>
                        <table id="products_table_saveable" className="products_table_saveable" cellPadding="0" cellSpacing="0" style={ { display: 'none' } }>
                            { this.renderProductsTableHeader(true) }
                            { this.renderProductsRows(PRODUCTS, true) }
                        </table>
                    </div>
                );
            } else {
                return <div className="table_holder"><h3>Мы не нашли ваших товаров в базе</h3></div>;
            }
        } else {
            return <div className="table_holder"><Loader /><div className="loader_content">Собираем статистику по товарам ...</div></div>
        }
    }

    renderImage = (PRODUCT) => {
        let SRC = PRODUCT.images.thumb;
        if ((typeof SRC !== "undefined") && (SRC !== "")) {
            return (
                <img
                    className="product_image"
                    src={ CONFIG.API_C_DOMAIN + SRC }
                />
            );
        }

        return false;
    }

    getProductGroups = (PRODUCT) => {
        let GROUPS = [];
        for (let i = 0; i < PRODUCT.groups.length; i++) {
            let GROUP = false;

            for (let j = 0; j < this.state.GROUPS.length; j++) {
                if (this.state.GROUPS[j].id.toString() == PRODUCT.groups[i].toString()) {
                    GROUP = this.state.GROUPS[j].title;
                }
            }

            if (GROUP) {
                GROUPS.push(<span key={ i } className="group_title">{ GROUP }</span>);
            }
        }

        return GROUPS;
    }

    renderProductStatuses = (PRODUCT) => {
        let STATUSES = [];
        if (parseInt(PRODUCT.archive) == 1) {
            STATUSES.push(
                <span key="archive" className="archive_label">Архив</span>
            );
        }
        if (parseInt(PRODUCT.disabled) == 1) {
            STATUSES.push(
                <span key="disabled" className="disabled_label">Отключен</span>
            );
        }

        if (STATUSES.length) {
            return (
                <div className="product_title_labels">
                    { STATUSES }
                </div>
            );
        }

        return null;
    }

    addAmountClassToCell = (AMOUNT) => {
        if (parseInt(AMOUNT) == 0) {
            return ' out_of_stock_cell';
        }

        return null;
    }

    fetchModalData = async (product_id, type) => {
        try {
            let SEND_DATA = {
                action: 'supplierProductsStatistics',
                supplier_apikey: this.props.USER.supplier_apikey,
                product_id: product_id,
                type: type
            };

            let data = await Request(SEND_DATA, CONFIG.API_GATE);
            return data
        } catch (error) {
        }

        return false
    }

    hideModalInfo = () => {
        this.setState({ INFO_MODAL: false })
    }

    showModalInfo = async (PRODUCT, type) => {
        const data = await this.fetchModalData(PRODUCT.id, type)
        if (!data) {
            return
        }

        let title = 'Информация';
        if (type == 'sales') {
            title = 'Продажи'
        } else if (type == 'activity') {
            title = 'Активность'
        } else if (type == 'writeoffs') {
            title = 'Списания'
        }

        this.setState({
            INFO_MODAL: {
                title: title,
                data: data
            }
        })
    }

    renderCheckbox = (PRODUCT) => {
        return (
            <input
                key={ PRODUCT.id + '_checkbox' }
                id={ PRODUCT.id + '_checkbox' }
                type="checkbox"
                onChange={ () => this.props.toggleProductInToOrderProducts(PRODUCT) }
                checked={ typeof this.props.TO_ORDER_PRODUCTS[PRODUCT.id] !== "undefined" }
            />
        )
    }

    renderProductsRows = (PRODUCTS, SAVEABLE) => {
        let ROWS = [];
        for (let i = 0; i < PRODUCTS.length; i++) {
            let PRODUCT = PRODUCTS[i];

            ROWS.push(
                <tr key={ i }>
                    { (typeof SAVEABLE !== "undefined") ? null : (<td className="cell-center">{ this.renderImage(PRODUCT) }</td>) }
                    <td><span className="product_title">{ PRODUCT.title }{ this.renderProductStatuses(PRODUCT) }</span></td>
                    <td>{ this.getProductGroups(PRODUCT) }</td>
                    <td className={ "cell-center " + this.addAmountClassToCell(PRODUCT.amount) }>{ PRODUCT.amount }</td>
                    <td className={ "cell-center" }>{ PRODUCT.reserved }</td>
                    <td className={ "cell-center" }>{ PRODUCT.total_amount }</td>
                    <td className="cell-center">{ PRODUCT.ed_izm }</td>

                    <td className="cell-center">{ PRODUCT.sales.today } { PRODUCT.ed_izm }</td>
                    <td className="cell-center">{ PRODUCT.sales_10 } { PRODUCT.ed_izm }{ (typeof SAVEABLE !== "undefined") ? null : (<a className="info_link" onClick={ () => this.showModalInfo(PRODUCT, 'sales') }><img src="/system_images/info.png" /></a>) }</td>

                    <td className="cell-center">{ PRODUCT.writeoffs_10 } { PRODUCT.ed_izm }{ (typeof SAVEABLE !== "undefined") ? null : (<a className="info_link" onClick={ () => this.showModalInfo(PRODUCT, 'writeoffs') }><img src="/system_images/info.png" /></a>) }</td>
                    <td className="cell-center">{ PRODUCT.activity }{ (typeof SAVEABLE !== "undefined") ? null : (<a className="info_link" onClick={ () => this.showModalInfo(PRODUCT, 'activity') }><img src="/system_images/info.png" /></a>) }</td>
                    { (typeof SAVEABLE !== "undefined" || this.state.USER.selforder == 0) ? null : (<td className="cell-center">{ this.renderCheckbox(PRODUCT) }</td>) }
                </tr>
            );
        }

        return (
            <tbody>
                { ROWS }
            </tbody>
        );
    }

    allSelect = () => {
        let PRODUCTS = this.filterProducts();

        if (Object.keys(this.props.TO_ORDER_PRODUCTS).length == PRODUCTS.length) {
            this.props.setProductsToOrder({})
        } else {
            let setProducts = {}
            for (let i = 0; i < PRODUCTS.length; i++) {
                let product = PRODUCTS[i]
                setProducts[product.id] = product
            }
            this.props.setProductsToOrder(setProducts)
        }
    }

    renderAllCheckbox = () => {
        let PRODUCTS = this.filterProducts();

        return (
            <div>
                <input type="checkbox" value="1" checked={ Object.keys(this.props.TO_ORDER_PRODUCTS).length == PRODUCTS.length } onChange={ () => this.allSelect() } />
            </div>
        )
    }

    renderProductsTableHeader = (SAVEABLE) => {
        return (
            <thead>
                <tr>
                    { (typeof SAVEABLE !== "undefined") ? null : (<th>фото</th>) }
                    <th>наименование</th>
                    <th>категории</th>
                    <th>свободный<br />остаток</th>
                    <th>в резерве</th>
                    <th>всего</th>
                    <th>единица<br />измерения</th>
                    <th>продажи<br />сегодня</th>
                    <th>продажи<br />за 10д</th>

                    <th>списания<br />за 10д</th>
                    <th>активность<br />за 30д</th>
                    { (typeof SAVEABLE !== "undefined" || this.state.USER.selforder == 0) ? null : (<th>В заказ{ this.renderAllCheckbox() }</th>) }
                </tr>
            </thead>
        );
    }

    renderFiter = () => {
        return (
            <div className="filter_head">
                <h1>Товары</h1>
                <Link to={ '/addproducts' } className="active_btn">добавить</Link>
                { this.renderSearchInput() }
                { this.renderGroupSelect() }
                { this.renderCheckboxes() }
                { this.renderXlsSaveButton() }
            </div>
        );
    }

    appendFilter = (data, type) => {
        let FILTER = this.state.FILTER;
        if (type == 'GROUP') {
            let value = data.target.value;
            if (value == 0) {
                value = null;
            }
            FILTER[type] = value;
        } else if (type == 'DISABLED') {
            FILTER[type] = !this.state.FILTER.DISABLED;
        } else if (type == 'ARCHIVE') {
            FILTER[type] = !this.state.FILTER.ARCHIVE;
        } else if (type == 'OUTOFSTOCK') {
            FILTER[type] = !this.state.FILTER.OUTOFSTOCK;
        } else {
            FILTER[type] = data.target.value;
        }

        this.setState({ FILTER: FILTER });
    }

    filterProducts = () => {
        let FILTER_RESULTS = [];
        let STRING = null;
        let COMPARE = null;

        for (let i = 0; i < this.state.PRODUCTS.length; i++) {
            let PRODUCT = this.state.PRODUCTS[i];
            let FOUND = true;

            if (FOUND) {
                let ARCHIVE_DEFAULT = 0;
                if (this.state.FILTER.ARCHIVE) {
                    ARCHIVE_DEFAULT = 1;
                }

                if (parseInt(PRODUCT.archive) == ARCHIVE_DEFAULT) {
                    FOUND = true;
                } else {
                    FOUND = false;
                }
            }

            if (FOUND) {
                if (this.state.FILTER.DISABLED == 1) {
                    if (parseInt(PRODUCT.disabled) == 1) {
                        FOUND = true;
                    } else {
                        FOUND = false;
                    }
                }
            }

            if (FOUND) {
                if (this.state.FILTER.OUTOFSTOCK == 1) {
                    if (parseInt(PRODUCT.amount) == 0) {
                        FOUND = true;
                    } else {
                        FOUND = false;
                    }
                }
            }

            if (FOUND) {
                if (this.state.FILTER.GROUP !== null) {
                    COMPARE = this.state.FILTER.GROUP.toString();

                    if (PRODUCT.groups.indexOf(COMPARE) == -1) {
                        FOUND = false;
                    } else {
                        FOUND = true;
                    }
                }
            }

            if (FOUND) {
                if (this.state.FILTER.TITLE !== null) {
                    STRING = PRODUCT.title.toUpperCase();
                    COMPARE = this.state.FILTER.TITLE.toUpperCase();

                    if (STRING.indexOf(COMPARE) !== -1) {
                        FOUND = true;
                    } else {
                        FOUND = false;
                    }
                }
            }

            if (FOUND) {
                FILTER_RESULTS.push(PRODUCT);
            }
        }
        return FILTER_RESULTS;

    }

    renderSearchInput = () => {
        if (this.state.LOADED) {
            return (
                <div className="filter_inputs_holder">
                    <div className="filter_element">
                        <input
                            type="text"
                            placehodler="Поиск"
                            value={ this.state.FILTER.TITLE }
                            onChange={ (text) => this.appendFilter(text, 'TITLE') }
                        />
                        <img className="search_icon" src="/system_images/search_icon.png" />
                    </div>
                </div>
            );
        }
    }

    renderXlsSaveButton = () => {
        if (this.state.LOADED) {
            return (
                <ReactHTMLTableToExcel
                    id="products_table_btn"
                    className="filter_btn"
                    table="products_table_saveable"
                    filename="tablexls"
                    sheet="ecomarket_products"
                    buttonText="Сохранить в XLS"
                />
            );
        }
    }

    renderCheckboxes = () => {
        if (this.state.LOADED) {
            return (
                <div className="filter_inputs_holder">
                    <input
                        type="checkbox"
                        id="outofstock"
                        name="outofstock"
                        value="1"
                        checked={ this.state.FILTER.OUTOFSTOCK }
                        onChange={ (input) => { this.appendFilter(input, 'OUTOFSTOCK') } }
                    />
                    <label htmlFor="outofstock">
                        <span></span>
                        Нет в наличии
                    </label>

                    <input
                        type="checkbox"
                        id="disabled"
                        name="disabled"
                        value="1"
                        checked={ this.state.FILTER.DISABLED }
                        onChange={ (input) => { this.appendFilter(input, 'DISABLED') } }
                    />
                    <label htmlFor="disabled">
                        <span></span>
                        Только отключенные
                    </label>

                    <input
                        type="checkbox"
                        id="archive"
                        name="archive"
                        value="1"
                        checked={ this.state.FILTER.ARCHIVE }
                        onChange={ (input) => { this.appendFilter(input, 'ARCHIVE') } }
                    />
                    <label htmlFor="archive">
                        <span></span>
                        Только архивные
                    </label>
                </div>
            );
        }
    }

    renderGroupSelect = () => {
        if ((this.state.LOADED) && (this.state.GROUPS)) {
            let OPTIONS = [];
            OPTIONS.push(
                <option key="default" value="0">Выбрать категорию</option>
            );
            for (let i = 0; i < this.state.GROUPS.length; i++) {
                let OPT = this.state.GROUPS[i];
                OPTIONS.push(
                    <option key={ i } value={ OPT.id }>{ OPT.title }</option>
                );
            }

            return (
                <div className="filter_inputs_holder">
                    <div className="filter_element">
                        <select
                            value={ this.state.FILTER.GROUP }
                            onChange={ (text) => this.appendFilter(text, 'GROUP') }
                        >
                            { OPTIONS }
                        </select>
                        <img className="select_icon" src="/system_images/angle.png" />
                    </div>
                </div>
            );
        }
    }

    renderToOrderBtn() {
        if (this.state.USER.selforder == 0) {
            return;
        }

        if (Object.keys(this.props.TO_ORDER_PRODUCTS).length) {
            return (
                <Link to="/createorder" className="floating_to_order_btn">
                    Сформировать заказ
                </Link>
            )
        }
    }

    render() {
        if (!this.state.USER) {
            return <Redirect to="/" />
        }

        return (
            <div className="main_content">
                <Helmet>
                    <title>Товары</title>
                </Helmet>
                { this.renderFiter() }
                { this.renderProducts() }
                { this.state.INFO_MODAL ?
                    <InfoModal data={ this.state.INFO_MODAL } close={ this.hideModalInfo } />
                    : null }
                { this.renderToOrderBtn() }
            </div>
        );
    }
}

export default withRouter(connect(
    mapStateToProps, mapDispatchToProps
)(Products))
